import React from "react";
import profileGif from "../../../../assets/images/gifs/add.gif";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "../../../../utils/helpers/enums/routes";
import { useSelector } from "react-redux";
import useStore from "../../../../hooks/useStore";

const ProfileCompletionModal: React.FC = ({}) => {
  const { setProfileModalOpen } = useStore();
  const profileModalOpen = useSelector(
    (state: any) => state.sharedReducer.profileModalOpen
  );

  const navigate = useNavigate();

  const onClose = () => {
    setProfileModalOpen(false);
  };

  const goToProfile = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setProfileModalOpen(false);

    setTimeout(() => {
      navigate(siteRoutes.parentGuardianDetails);
    }, 100);
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        // Only close if clicking on the backdrop, not the modal content
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-[85%] sm:w-[364px] text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center">
          <img
            src={profileGif}
            alt="Complete Profile"
            className="w-32 mx-auto mb-2"
          />
        </div>
        <h2 className="text-base text-primaryBlueText font-semibold mb-4">
          Complete your profile
        </h2>
        <p className="text-labelTextColor text-sm mb-4">
          Complete your profile to register for events and get personalized
          Recommendations.
        </p>
        <button
          onClick={goToProfile}
          className="bg-primaryBlueText text-white px-4 py-2 rounded-full"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;
